export const RICH_TEXT_EDITOR_OPTIONS = {
  formats: [
    'underline',
    'strike',
    'bold',
    'italic',
    'image',
    'link',
    'align',
    'size'
  ],

  modules: {
    clipboard: {
      matchVisual: false
    }
  }
}
